import React, { useState, useEffect } from "react";
import { Card, Typography, Space, notification } from "antd";
import { PlusOutlined, TeamOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const AddCard = ({ setProductCount, setEditModes }) => {
  const currentEstimate = useSelector((state) => state.currentEstimate);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleAddProduct = () => {
    setEditModes((prev) => [...prev, true]);
    setProductCount((prev) => prev + 1);
  };

  useEffect(() => {
    if (currentEstimate.id) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [currentEstimate.id]);

  if (isDisabled) {
    return (
      <Card
        style={isDisabled ? { width: "100%", height: "100%", opacity: 0.5, cursor: "not-allowed" } : { width: "100%", height: "100%" }}
        styles={{
          body: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          },
        }}
        onClick={() => {
          if (!isDisabled) {
            handleAddProduct();
          } else {
              notification.error({
                message: "Error",
                description: (
                <span>
                  Please initialize clinic and client information before adding products by clicking on the <TeamOutlined style={{ marginRight: 8 }} /> button.
                </span>
                ),
                placement: "bottomRight",
              });
          }
        }}
      >
        <Space direction="vertical" align="center">
          <PlusOutlined style={{ fontSize: "100px" }} />
          <Typography.Title level={4}>Add Product</Typography.Title>
          <Typography.Text type="secondary">
            Click to add a new product
          </Typography.Text>
        </Space>
      </Card>
    );
  }

  return (
    <Card
      style={isDisabled ? { width: "100%", height: "100%", opacity: 0.5, cursor: "not-allowed" } : { width: "100%", height: "100%" }}
      styles={{
        body: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        },
      }}
      onClick={() => {
        if (!isDisabled) {
          handleAddProduct();
        } else {
            notification.error({
              message: "Error",
              description: (
              <span>
                Please initialize clinic and client information before adding products by clicking on the <TeamOutlined style={{ marginRight: 8 }} /> button.
              </span>
              ),
              placement: "bottomRight",
            });
        }
      }}
    >
      <Space direction="vertical" align="center">
        <PlusOutlined style={{ fontSize: "100px", color: "#005DA9" }} />
        <Typography.Title level={4}>Add Product</Typography.Title>
        <Typography.Text type="secondary">
          Click to add a new product
        </Typography.Text>
      </Space>
    </Card>
  );
};

export default AddCard;
